// @flow
import React, { Component, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import VideoModal from './VideoModal';

import style from './Discover.scss';
import icons from '../../../../assets/styles/icons.scss';

type Props = {
  +color?: 'white' | 'lightBlue' | 'orange' | 'green';
  +url: string;
  +text?: string;
  +handleClick?: () => void;
  +hasIcon?: boolean;
};

type State = {
  modalVisible: boolean;
};

export default class Discover extends Component<Props, State> {

  state = {
    modalVisible: false,
  };

  static defaultProps = {
    color: 'white',
    hasIcon: true,
  };

  handleOpenModal = () => {
    const { handleClick } = this.props;
    if (!this.state.modalVisible ) {
      if (handleClick) {
        handleClick();
      }
      this.setState({ modalVisible: true });
    }
  };

  handleCloseModal = () => {
    this.setState({ modalVisible: false });
  };

  render() {
    const { color, url, text } = this.props;
    const { modalVisible } = this.state;

    return (
      <Fragment>
        <div className={classNames(style.discover, style[color])}
                onClick={this.handleOpenModal}>
          <Fragment>
            <p>{text}</p>
          </Fragment>
          <Fragment>
            <FormattedMessage id="home.howWorks.title">{
              txt => <h3 className={style.title}>{txt}</h3>
            }</FormattedMessage>
            <section className={style.buttonWrap}>
              <i className={icons.symbolPlay}/>
            </section>
            <VideoModal handleClose={this.handleCloseModal}
                        modalVisible={modalVisible}
                        url={url}/>
          </Fragment>
        </div>
      </Fragment>
    );
  }
}

Discover.propTypes = {
  color: PropTypes.string,
  url: PropTypes.string.isRequired,
  text: PropTypes.string,
  handleClick: PropTypes.func,
  hasIcon: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/modules/home/components/Discover/Discover.jsx